import React, { useCallback, useState, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage } from "react-intl";
import { BigButton } from "../../../../../../components/button";
import { useDispatch } from "react-redux";
import { TOGGLE_UI_LOGIN } from "../../../../../../../store/actions/ui";
import { TOTAL_STATUS_UNPAID } from "../../../../../me/utils/constant";

const MessengerCheckBtn =  props =>{
    useStyles(cls);
    const { customer, transaction } = props;
    const dispatch = useDispatch();

    const getPayUrl = useMemo(() =>{
        return transaction.mercadopagoPayURL || transaction.boletoPayCodeURL || transaction.payCodeUrl;
    }, [transaction]);

    const toOrderClickDetail = useCallback((transaction, getPayUrl) =>{
        if(transaction.fulfillmentStatus === TOTAL_STATUS_UNPAID){
            if(!getPayUrl){
                window.location.href = `/checkout/${transaction.id}`;
            }else{
                window.location.href = getPayUrl;
            }
        }else {
            window.location.href = `/user/order/detail/${transaction.id}`
        }
    }, []);


    const handleViewOrder = useCallback(() =>{
        try {
            if(customer?.id) {
                toOrderClickDetail(transaction, getPayUrl);
            } else {
                dispatch({
                    type: TOGGLE_UI_LOGIN,
                    payload: {
                        showLogin: true,
                        eventType: "cart",
                        redirectUrl: `/user/order/detail/${transaction.id}`,
                        callBack: function () {
                            toOrderClickDetail(transaction, getPayUrl);
                        }
                    }
                })
            }

			if(window.GeekoSensors){
				window.GeekoSensors.Track('ELClick', {
					clicks: 'check_order'
				})
			}
		}catch (e){
			console.log(e)
		}
    }, [customer, transaction, getPayUrl]);

    return <div className={cls.MessengerCheckBtn}>
        <div className={cls.BtnContainer}>
            <BigButton onClick={handleViewOrder}><FormattedMessage id="verify_check_order" defaultMessage="Check Order" /></BigButton>

            <BigButton onClick={() =>{
                window.location.href = '/';
            }}><FormattedMessage id="continue_shopping" defaultMessage="Continue Shopping" /></BigButton>
        </div>
    </div>
}

export default MessengerCheckBtn;